import React from 'react';
import { X, Copy, Smartphone, ScanLine, MessageSquare } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

interface ProUpgradeModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ProUpgradeModal: React.FC<ProUpgradeModalProps> = ({ isOpen, onClose }) => {
    const { user } = useAuth();

    if (!isOpen) return null;

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
        alert("Copied to clipboard!");
    };

    const transferContent = user ? `ebookvatli365_${user.email}` : 'ebookvatli365_your-email';

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden relative animate-in fade-in zoom-in duration-300">
                <button 
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors z-10"
                >
                    <X className="w-6 h-6 text-gray-500" />
                </button>

                <div className="flex flex-col md:flex-row">
                    {/* QR Section */}
                    <div className="md:w-1/2 bg-gray-50 p-8 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-gray-100">
                        <div className="bg-white p-4 rounded-2xl shadow-lg mb-4">
                            <img 
                                src="/qr-sacombank.jpg" 
                                alt="Payment QR" 
                                className="w-full aspect-square object-contain"
                            />
                        </div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2">
                            <ScanLine className="w-4 h-4" /> Quét mã để thanh toán
                        </p>
                    </div>

                    {/* Info Section */}
                    <div className="md:w-1/2 p-8">
                        <h3 className="text-2xl font-black text-gray-900 mb-2">Nâng cấp <span className="text-blue-600">Ebook PRO</span></h3>
                        <p className="text-gray-500 text-sm mb-6">Mở khóa toàn bộ bài học, trắc nghiệm và tính năng AI cao cấp.</p>

                        <div className="space-y-4 mb-6">
                            <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                                <div className="flex justify-between items-center mb-1">
                                    <span className="text-xs font-bold text-blue-600 uppercase">Số tài khoản</span>
                                    <button onClick={() => copyToClipboard('040062507464')} className="text-blue-400 hover:text-blue-600">
                                        <Copy size={14} />
                                    </button>
                                </div>
                                <p className="font-mono font-bold text-lg text-gray-900">040062507464</p>
                                <p className="text-xs text-gray-500">Sacombank - TRAN QUOC QUAN</p>
                            </div>

                            <div className="bg-green-50/50 p-4 rounded-xl border border-green-100">
                                <div className="flex justify-between items-center mb-1">
                                    <span className="text-xs font-bold text-green-600 uppercase">Nội dung chuyển khoản</span>
                                    <button onClick={() => copyToClipboard(transferContent)} className="text-green-400 hover:text-green-600">
                                        <Copy size={14} />
                                    </button>
                                </div>
                                <p className="font-mono font-bold text-gray-900 break-all">{transferContent}</p>
                            </div>
                        </div>

                        <div className="space-y-3">
                            <div className="flex items-start gap-3 text-sm">
                                <div className="p-1.5 bg-orange-100 rounded-lg text-orange-600 mt-0.5">
                                    <Smartphone className="w-4 h-4" />
                                </div>
                                <p className="text-gray-600">
                                    Sau khi chuyển khoản, vui lòng gửi ảnh minh chứng qua Zalo: <span className="font-bold text-gray-900">0978531191</span>
                                </p>
                            </div>
                            <div className="flex items-start gap-3 text-sm">
                                <div className="p-1.5 bg-blue-100 rounded-lg text-blue-600 mt-0.5">
                                    <MessageSquare className="w-4 h-4" />
                                </div>
                                <p className="text-gray-600">
                                    Hệ thống sẽ kích hoạt tài khoản của bạn trong vòng 5-10 phút.
                                </p>
                            </div>
                        </div>

                        <button 
                            onClick={() => window.open(`https://zalo.me/0978531191`, '_blank')}
                            className="w-full mt-8 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition shadow-lg shadow-blue-200 flex items-center justify-center gap-2"
                        >
                            Gửi minh chứng qua Zalo
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProUpgradeModal;
